import { createAction } from "redux-actions";

export const UPDATE_USERS = "UPDATE_USERS";
export const updateUsers = createAction(UPDATE_USERS);

export const DELETE_USER = "DELETE_USER";
export const deleteUser = createAction(DELETE_USER);
